<template>
  <div>
    <div class="has-background-white is-padding-bottom-xsmall is-margin-bottom-small">
      <div
        class="is-padding-top is-padding-bottom"
        v-if="program.pictures && program.pictures.length > 0">
        <div class="is-relative">
          <swiper
            ref="awesomeSwiper"
            :options="swiperOption"
            class="swiper-container-pagination-top"
            :class="{'swiper-slide-to-clicked-slide': swiperOption.slideToClickedSlide}"
            id="mySwiper"
            @slideChange="slideChange">
            <div
              class="swiper-pagination swiper-pagination-bullet--dashed"
              slot="pagination"
              v-if="program.pictures && program.pictures.length > 1"></div>
            <swiper-slide
              v-for="(picture, idx) in program.pictures"
              :key="idx">
              <img :src="picture.cloudinary_id | cloudinary({aspect_ratio: '16:9', crop: 'fill', quality: 70})">
            </swiper-slide>
          </swiper>
        </div>
        <div
          class="field is-grouped swiper-btns-video has-background-light"
          v-if="program.videos && program.videos.length > 0">
          <div
            v-for="(v, idx) in program.videos"
            :key="idx"
            class="control">
            <button
              v-if="idx >= 0"
              class="button has-background-light is-radiusless"
              @click="toggleVideo(v)">
              <div class="has-background-primary has-text-white is-padding-left-xxsmall is-padding-right-xxsmall is-margin-right-xxsmall">
                <span class="is-size-6"><i class="fas fa-video fa-lg"></i></span>
              </div>
              <span class="is-size-6 is-transform-none">Vidéo de présentation ({{ (idx + 1) }})</span>
            </button>
          </div>
        </div>
      </div>
      <div class="has-background-white is-border-bottom">
        <div class="columns is-vcentered is-gapless is-border-bottom is-border-top has-background-light is-marginless">
          <div class="column is-padding-top-small is-padding-bottom-small is-padding-left">
            <b>Document<span v-if="documents.length > 1">s</span> programme</b>
          </div>
          <div class="column is-narrow">
            <a
              v-if="checkedDocuments && checkedDocuments.length === 1"
              class="page-header-btn is-success is-small is-padding-left-small is-padding-right-small"
              target="_blank"
              :href="checkedDocuments[0].path"
              :download="checkedDocuments[0].filename">
              <span class="icon is-padding-right-xsmall">
                <i
                  class="fas"
                  :class="loadingDownloadDoc ? 'fa-spinner fa-spin' : 'fa-cloud-download-alt'"></i>
              </span>
              <span class="has-text-weight-medium">Télécharger document</span>
            </a>
            <a
              v-if="checkedDocuments && checkedDocuments.length > 1"
              class="page-header-btn is-success is-small is-padding-left-small is-padding-right-small"
              @click="downloadDocuments">
              <span class="icon is-padding-right-xsmall">
                <i
                  class="fas"
                  :class="loadingDownloadDoc ? 'fa-spinner fa-spin' : 'fa-cloud-download-alt'"></i>
              </span>
              <span class="has-text-weight-medium">Télécharger documents</span>
            </a>
          </div>
        </div>
        <div
          v-for="(document, index) in documents"
          :key="'tr' + index"
          class="columns is-vcentered is-gapless is-marginless is-padding-right is-padding-left is-padding-top-xxsmall is-padding-bottom-xxsmall is-minH50p"
          :class="{'is-border-top': index > 0}"
          :id="document.cloudinary_id">
          <div class="column is-narrow is-size-6 is-margin-right-xxsmall">
            <span class="icon is-small"><i class="fal fa-file-pdf"></i></span>
          </div>
          <div class="column is-size-6">
            <a
              target="_blank"
              :href="document.path"
              :download="document.filename">{{ document.filename }}</a>
          </div>
          <div class="column is-narrow is-size-6 is-margin-right-xsmall">
            <a
              href="#"
              class=""
              @click="selectDocument(document)">
              <span class="is-italic">Sélectionner</span>
              <!--<span class="icon is-small is-size-5">
                <i class="far fa-lg fa-chevron-circle-down"></i>
              </span>-->
            </a>
          </div>
          <div class="column is-narrow">
            <div class="dropdown is-hoverable is-right">
              <div class="dropdown-trigger">
                <button
                  class="button is-xsmall is-circle "
                  @click="selectDocument(document)"
                  :class="[{'is-dark is-outlined':!isChecked(document), 'is-success':isChecked(document)}]">
                  <span
                    v-if="!isChecked(document)"
                    class="icon is-small"><i class="far fa-lg fa-chevron-down"></i></span>
                  <span
                    v-else
                    class="icon is-small"><i class="far fa-lg fa-check"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="program.descriptions && program.descriptions.length">
        <div
          class="columns is-centered is-margin-top-large is-margin-bottom is-gapless"
          v-for="(description, index) in program.descriptions"
          :key="index">
          <div class="column content ql-editor is-padding-right is-padding-left">
            <h2><strong>{{ description.title }}</strong></h2>
            <p v-html="description.text"></p>
          </div>
        </div>
      </template>
      <div
        class="columns is-centered is-margin-top is-margin-bottom is-gapless"
        v-else>
        <div class="column content is-padding-right is-padding-left">
          <p>Aucune description.</p>
        </div>
      </div>
      <cta-to-promoteur
        class="is-sticky--bottom is-margin-left-auto is-margin-right is-margin-top"
        @clickOnCta="$emit('openModalTicket');"></cta-to-promoteur>
    </div>
  </div>
</template>

<script>
import { DefaultValues, Sort } from '@/mixins'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import CtaToPromoteur from '@/components/utils/CtaToPromoteur'
export default {
  name: 'ProgramDistributeurInfos',
  components: {
    swiperSlide,
    swiper,
    CtaToPromoteur
  },
  mixins: [DefaultValues, Sort],
  props: {
    programLots: {
      type: Array
    },
    program: {
      required: true
    }
  },
  data () {
    return {
      loadDocuments: this.getProgramLots,
      sortBy: {},
      filters: {},
      lotListTab: 'Logement',
      checkedDocuments: [],
      loadingDownloadDoc: false
    }
  },
  computed: {
    lotListLinks () {
      return [
        { link: 'Logement', label: `${this.filteredLogements.length} logement(s)` },
        { link: 'Parking', label: `${this.filteredParkings.length} parking(s)` }
      ]
    },
    filteredLogements () {
      if (this.programLots && this.programLots.length) {
        return this.programLots.filter(x => x.nature !== 'parking')
      }
      return []
    },
    filteredParkings () {
      if (this.programLots && this.programLots.length) {
        return this.programLots.filter(x => x.nature === 'parking')
      }
      return []
    },
    documents () {
      return this.program.documents.filter(x => x.destination && x.destination.includes('program'))
    },
    swiper () {
      return this.$refs.awesomeSwiper.swiper
    },
    swiperOption () {
      // autoHeight: false,
      let options = {
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 1.10,
        centeredSlides: true,
        slideToClickedSlide: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      }
      return options
    }
  },
  methods: {
    getProgramLots () {
      this.$emit('getProgramLots', this.filters)
    },
    slideChange () {
      this.$nextTick(() => {
        let current = document.querySelector('.swiper-slide-active')
        this.currentSlide = current.id
      })
    },
    toggleVideo (v) {
      let params = { source: v }
      this.$store.commit('setModal', { mode: 'VIDEO_PREVIEW', params })
    },
    async downloadDocuments () {
      try {
        await this.$api.post(this.$resources.EXPORT_FILES, { sources: this.checkedDocuments, download_name: this.documentName })
        this.$toasted.global.success('Vous allez recevoir vos fichiers par mail')
        this.checkedDocuments = []
      } catch (e) {
        this.$toasted.global.danger('Erreur lors du téléchargement des fichiers.')
      }
    },
    isChecked (document) {
      return this.checkedDocuments.map(x => x.cloudinary_id).includes(document.cloudinary_id)
    },
    selectDocument (document) {
      let idx = this.checkedDocuments.findIndex(x => x.cloudinary_id === document.cloudinary_id)
      if (idx >= 0) {
        this.checkedDocuments.splice(idx, 1)
      } else {
        this.checkedDocuments.push(document)
      }
    }
  }
}
</script>

<style>
  .content p {
    margin-bottom: 0 !important;
  }
</style>
